import type { ExperimentLayer } from '../../../common/types';

// Filter input types
export enum ConfluenceGraphQLDateFilterFieldType {
	LASTMODIFIED = 'LASTMODIFIED',
	CREATED = 'CREATED,',
}

export interface ConfluenceGraphQLFilterVariablesType {
	contributorsFilter?: string[] | null;
	isVerified?: boolean | null;
	range?: {
		field: ConfluenceGraphQLDateFilterFieldType;
		gt?: string | null;
		lt?: string | null;
	} | null;
	spacesFilter?: string[] | null;
	titleMatchOnly?: boolean;
}

export interface ConfluenceGraphQLSearchVariablesMapper {
	analyticsInfo?: { queryVersion: number; searchSessionId: string };
	cloudId: string;
	contentEntities?: string[];
	experimentId?: string;
	experimentLayers?: ExperimentLayer[];
	filters: any[];
	includeAncestors?: boolean;
	pageBlogAttachmentLimit?: number;
	query: string;
	shadowExperimentId?: string;
	spaceLimit?: number;
}

export interface ConfluenceGraphQLSearchVariables {
	cloudIdARI: string;
	confluenceFilters: ConfluenceGraphQLFilterVariablesType;
	contentEntities: string[];
	experimentContext: {
		experimentId?: string;
		experimentLayers?: ExperimentLayer[];
		shadowExperimentId?: string;
	};
	includeAncestors: boolean;
	includeSpaces: boolean;
	pageBlogAttachmentLimit: number;
	query: string;
	queryVersion?: number;
	searchSessionId?: string;
	spaceLimit: number;
}

export interface ConfluenceGraphQLAncestor {
	id: string;
	title: string | null;
}

export interface ConfluenceGraphQLContentNode {
	confluenceEntity?: {
		ancestors: ConfluenceGraphQLAncestor[] | null;
	} | null;
	iconCssClass?: string | null;
	id: string;
	lastModified?: string | null;
	space?: {
		id: string;
		name?: string | null;
	} | null;
	title: string;
	type: 'page' | 'blogpost' | 'attachment';
	url: string;
}

export interface ConfluenceGraphQLSpaceNode {
	iconPath?: string;
	id: string;
	key?: string;
	title: string;
	type: 'space';
	url: string;
}

export interface ConfluenceGraphQLSearchQueryType {
	search: {
		pageBlogAttachments: {
			edges: {
				node?: ConfluenceGraphQLContentNode | null;
			}[];
			totalCount?: number | null;
		};
		spaces: {
			edges: {
				node?: ConfluenceGraphQLSpaceNode | null;
			}[];
		};
	};
}
